// extracted by mini-css-extract-plugin
module.exports = {"align":"Align_align_1l_0I","left":"Align_left_PPr6Y","right":"Align_right_2FrG9","center":"Align_center_1ZXww","spaceBetween":"Align_spaceBetween_3KZRl","ignoreChildren":"Align_ignoreChildren_atHpG"};
    if(module.hot) {
      // 1789136761452
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  